import { LogOut, Store, Package } from "lucide-react";
import { useDeviceSession } from "../../application/hooks/useDeviceSession";
import { salirDeLaTerminal } from "../../application/salir";

/**
 * Configuración de la terminal.
 *
 * Ya no hay "cambiar PIN": en v2 la caja no tiene PIN propio, tiene un `device_token` que el
 * manager puede revocar desde /admin/terminales. Cambiar quién puede usar esta caja es una
 * decisión del comercio, no de la caja — por eso vive en el panel y no acá.
 */
export default function SettingsPage() {
  const { session, lightning } = useDeviceSession();

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold">Configuración</h1>

      <div className="mb-4 rounded-lg border border-border-default bg-bg-surface p-4">
        <div className="mb-3 flex items-center gap-2">
          <Store size={16} className="text-text-secondary" />
          <h2 className="font-medium">Esta terminal</h2>
        </div>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between">
            <dt className="text-text-secondary">Comercio</dt>
            <dd data-testid="tenant-name">{session?.tenant.name ?? "—"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-text-secondary">Caja</dt>
            <dd>{session?.terminal.name ?? "—"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-text-secondary">Permiso</dt>
            <dd>{session?.terminal.role === "manager" ? "Encargado" : "Cajero"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-text-secondary">Cobra con</dt>
            <dd>{lightning ? "Efectivo y bitcoin" : "Sólo efectivo"}</dd>
          </div>
        </dl>
        {!lightning && (
          <p className="mt-3 rounded-md bg-warning/10 px-3 py-2 text-xs text-warning">
            El cobro con bitcoin está apagado porque el comercio no tiene una wallet
            conectada. Se conecta en <span className="font-mono">Panel → Wallet</span>.
          </p>
        )}
      </div>

      <div className="mb-4 rounded-lg border border-border-default bg-bg-surface p-4">
        <div className="mb-2 flex items-center gap-2">
          <Package size={16} className="text-text-secondary" />
          <h2 className="font-medium">Productos</h2>
        </div>
        <p className="text-sm text-text-secondary">
          El catálogo se administra desde el panel del comercio, no desde una caja.{" "}
          <a href="/admin/catalogo" className="text-accent hover:text-accent-hover">
            Ir a Panel → Catálogo
          </a>
        </p>
      </div>

      <div className="rounded-lg border border-border-default bg-bg-surface p-4">
        <button
          data-testid="desconectar"
          onClick={salirDeLaTerminal}
          className="flex items-center gap-2 text-sm text-error hover:text-error/80"
        >
          <LogOut size={16} />
          Desconectar esta terminal
        </button>
        <p className="mt-2 text-xs text-text-secondary">
          Vas a necesitar un código de pareo nuevo para volver a usarla.
        </p>
      </div>
    </div>
  );
}
